module.exports = __webpack_public_path__ + "img/Menu.c04120cb.svg";